import _ from 'lodash'
import Vue from 'vue'
import router from '@/router'

import listService from '@/services/listService'
import userService from '@/services/userService'

const state = {
  lists: [], // i dont know what this is supposed to hold?
  homePageLists: [],
  currentListId: null,
  copyItemModal: {
    show: false,
    item: null,
    options: []
  }
}

const getters = {
  currentList: state => {
    return _.find(state.lists, {id: state.currentListId}) || null
  },
  lists: state => state.lists
}

const actions = {
  getList ({ commit }, list_id) {
    listService.fetchList(list_id)
      .then(list => {
        commit('setLists', [list])
        commit('setCurrentListId', list.id)
      })
  },
  getLists ({ commit }) {
    listService.fetchLists()
      .then(lists => {
        commit('setLists', lists)
      })
  },
  createList ({ commit, state }, data) {
    listService.createList(data)
      .then(data => {
        let lists = _.clone(state.lists)
        lists.unshift(data)
        commit('setLists', lists)
        router.push(`/list/${data.id}`)
      })
  },
  editList ({ commit }, data) {
    commit('updateList', data)
    listService.editList(data)
      .then(data => {
        commit('updateList', data)
      })
  },
  deleteList ({ commit }, data) {
    listService.deleteList(data.id).then(data => {
      commit('removeList', data.id)
    })
  },
  saveList ({ commit }, data) {
    commit('updateList', data)
    listService.saveList(data.id, data.items).then(data => {
      commit('updateList', data)
    })
  },
  editItem ({ commit }, data) {
    listService.editItem(data.list_id, data.item).then(data => {
      commit('updateList', data)
    })
  },
  deleteItem ({ commit }, data) {
    listService.deleteItem(data.list_id, data.item_id).then(data => {
      commit('updateList', data)
    })
  },
  getHomePageLists ({ commit }, data) {
    listService.fetchLists(data).then(data => {
      commit('setHomePageLists', data)
    })
  },
  copyList ({ commit }, data) {
    return listService.copyList(data).then(list => {
      commit('setLists', [list])
      commit('setCurrentListId', list.id)
      return list
    })
  },
  showCopyItemModal ({ commit, rootState }, data) {
    commit('showCopyItemModal', data)
    userService.fetchUserDetail(rootState.users.user.username).then(data => {
      commit('setModalOptions', data.lists)
    })
  },
  hideCopyItemModal ({ commit }) {
    commit('hideCopyItemModal')
    commit('setModalOptions', [])
  }
}

const mutations = {
  setLists (state, lists) {
    state.lists = lists
  },
  setHomePageLists (state, lists) {
    state.homePageLists = lists
  },
  setCurrentListId(state, list_id) {
    state.currentListId = list_id
  },
  updateList (state, list) {
    let idx = _.findIndex(state.lists, {id: list.id})
    Vue.set(state.lists, idx, list)
  },
  removeList (state, list_id) {
    state.lists = _.filter(state.lists, i => i.id !== list_id)
    state.currentListId = null
  },
  showCopyItemModal (state, item) {
    state.copyItemModal.show = true
    state.copyItemModal.item = item
  },
  hideCopyItemModal (state) {
    state.copyItemModal.show = false
    state.copyItemModal.item = null
  },
  setModalOptions (state, lists) {
    state.copyItemModal.options = lists
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}